import script from "./LeftBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftBottom.vue?vue&type=script&setup=true&lang=js"

import "./LeftBottom.vue?vue&type=style&index=0&id=7083037c&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7083037c"]])

export default __exports__